export const DialogFilePreviewConst = {
  CLOSE_MODAL: 'Closed',
  CONFIRM: 'Confirm',
  DATAURLFORMAT: 'image/png',
  DEGREES: 45,
  DOWNLOADBUTTON: 'download-button',
  DOWNLOADPDFEXTENSION: '.pdf',
  EVIDENCE_IDENTIFIER: 'EV',
  FILE_NAME: 'Evidence',
  HEIGHT_MODAL: '98%',
  IMAGEFORMAT: 'PNG',
  IMAGEPREVIEW: '.image-preview',
  IMAGEPREVIEWDIALOG: 'image-preview-dialog',
  IMGWIDTH: 210,
  IN: 'in',
  KEY_EVIDENCE_RELEASE_FOLIO_DATA: 'evidenceReleaseFolioData',
  KEY_SHIPMENT_REQUEST_DATA: 'shipmentRequestData',
  KEY_SHIPMENT_TO_LOAD_PLAN: 'shipmentToLoadPlan',
  LEFT: 'left',
  MAXWIDTHPDF: 1200,
  MAX_WIDTH_MODAL: '98%',
  MIME_PDF: 'application/pdf',
  MODAL_CLASS: 'background-dialog-image',
  NO_INFO: 'Sin Información',
  ORIGIN_EVIDENCE_CONTROL: 'Control de Evidencias',
  OUT: 'out',
  PAGEHEIGHT: 297,
  PAGEORIENTATION: 'p',
  PAGESIZE: 'a4',
  PDFEXTENSION: 'application/pdf',
  PDFHORIZONTALALIGN: 0,
  PDFMEASUREMENTUNIT: 'mm',
  PDFSCALE: 0.9,
  PDFVERTICALALIGN: 30,
  PDF_HEIGHT_ADDED: 15,
  PRINTSECTION: 'print-section',
  QUALITYIMAGE: 1.0,
  SCALEADD: 0.1,
  SCALEMAX: 1.8,
  SCALEMAXVALID: 1.7,
  SCALEMIN: 1.0,
  SCALEMINVALID: 1.1,
  TRANSFORM: 'transform',
  WIDTH_MODAL: '98%',
  ZERO: 0,
};

export const enum ResourceType {
  IMAGE_OR_PDF,
  LOAD_PLAN,
  EVIDENCE_RELEASE_DOC,
  EVIDENCE_DOC,
  SHIPMENT_REQUEST_DOC
}
